import * as network from '../network'
import { ThreeView } from '../../view3d/webcad';

export class renderingButton implements network.playerStatus
{
   constructor() {
   }

    public onChange(status) {
        const element = document.getElementById('btnRendering');
        if (element == null) return;

        if (status === network.statustype.connect) {
            element.innerHTML = '<span class="jp">◎接続中</span><span class="en">◎Connecting</span><span id="servertimerContainer"><span class="jp">残り</span><span class="en">Remaining</span><span id="servertimer"></span></span>';
        }
        if (status == network.statustype.disconnect || status == network.statustype.unknown) {
            element.innerHTML = '<span class="jp">高画質レンダリング 依頼</span><span class="en">High quality rendering start</span>';
        }
   }
}
